import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { INVOICE_SUBTYPES } from 'Utils/constants';

export default function InvoicesItemDescription({ invoice }) {
    const { t } = useTranslation('invoices');

    const INVOICES_SUBTYPES_NAMES = {
        [INVOICE_SUBTYPES.STANDARD]: t('invoice-standard'),
        [INVOICE_SUBTYPES.STANDARD_CORRECTIVE]: t('invoice-standard-corrective'),
        [INVOICE_SUBTYPES.SIMPLIFIED]: t('invoice-simplified'),
        [INVOICE_SUBTYPES.SIMPLIFIED_CORRECTIVE]: t('invoice-simplified-corrective'),
        [INVOICE_SUBTYPES.QUOTE]: t('invoice-quote'),
        [INVOICE_SUBTYPES.PROFORMA]: t('invoice-proforma'),
        [INVOICE_SUBTYPES.DELIVERY_NOTE]: t('invoice-delivery-note'),
    };

    const invoiceLabel = [invoice.identifier ? invoice.identifier : null, INVOICES_SUBTYPES_NAMES[invoice.subtype]]
        .filter(Boolean)
        .join(' • ');

    if (invoice.tax_authority_provider_status === 'pending_cancellation') {
        return (
            <span className="rounded-md bg-[#6050C6]/10 text-2xs uppercase px-1.5 py-0.5 font-semibold text-[#6050C6] tracking-wide">
                {t('cancelling')}
            </span>
        );
    }

    if (invoice.tax_authority_provider_status === 'cancelled') {
        return (
            <span className="rounded-md bg-gray-300/20 text-2xs uppercase px-1.5 py-0.5 font-semibold text-gray-500 tracking-wide">
                {t('cancelled')}
            </span>
        );
    }

    if (invoice.tax_authority_provider_status === 'error_cancellation') {
        return (
            <span className="rounded-md bg-danger/20 text-2xs uppercase px-1.5 py-0.5 font-semibold text-danger tracking-wide">
                {t('cancellation-error-invoice-warning')}
            </span>
        );
    }

    if (invoice.tax_authority_provider_status === 'processing') {
        return (
            <span className="rounded-md bg-[#6050C6]/10 text-2xs uppercase px-1.5 py-0.5 font-semibold text-[#6050C6] tracking-wide">
                {t('issuing')}
            </span>
        );
    }

    if (invoice.tax_authority_provider_status === 'draft') {
        return (
            <span className="rounded-md bg-dark-blue/10 text-2xs uppercase px-1.5 py-0.5 font-semibold text-gray-500 tracking-wide">
                {invoice.subtype === INVOICE_SUBTYPES.DELIVERY_NOTE ? t('invoice-delivery-note-draft') : t('draft')}
            </span>
        );
    }

    if (invoice.tax_authority_provider_status === 'error') {
        return (
            <span className="rounded-md bg-danger/20 text-2xs uppercase px-1.5 py-0.5 font-semibold text-danger tracking-wide">
                {t('issue-error-invoice-warning')}
            </span>
        );
    }

    if (invoice.tax_authority_provider_status === 'error_issuing_solved') {
        return (
            <span className="rounded-md bg-dark-blue/10 text-2xs uppercase px-1.5 py-0.5 font-semibold text-gray-500 tracking-wide">
                {t('error-issuing-solved')}
            </span>
        );
    }

    if (invoice.invoice_duplicated_id) {
        return (
            <span className="rounded-md bg-[#FF7F5B]/20 text-2xs uppercase px-1.5 py-0.5 font-semibold text-[#FF7F5B] tracking-wide">
                {t('duplicate-invoice-warning')}
            </span>
        );
    }

    return (
        <div className="flex items-center gap-1 min-w-0">
            {invoice.integration && (
                <img
                    src={invoice.integration.icon}
                    alt={invoice.integration.name}
                    className="inline-block w-3 h-auto shrink-0 ml-1"
                />
            )}
            <span className="text-xs truncate">{invoiceLabel}</span>
        </div>
    );
}

InvoicesItemDescription.propTypes = {
    invoice: PropTypes.object.isRequired,
};
